import { Alert, Button, Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { FiAlertTriangle } from "react-icons/fi";

interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
}

export function ErrorState({ title, message, onRetry }: ErrorStateProps) {
  const { t } = useTranslation("common");
  return (
    <Alert
      color="red"
      title={title ?? t("states.error")}
      icon={<FiAlertTriangle aria-hidden="true" />}
    >
      <Stack gap="sm">
        <span>{message}</span>
        {onRetry ? (
          <Button onClick={onRetry} variant="light" size="xs">
            {t("actions.retry")}
          </Button>
        ) : null}
      </Stack>
    </Alert>
  );
}
